const tracks = [];

let audioElems = document.querySelectorAll('[data-audio-item]');

audioElems.forEach((el, index) => {
    let img = el.getAttribute('data-img');
    let title = el.getAttribute('data-title');
    let artist = el.getAttribute('data-author');
    let url = el.getAttribute('data-url');

    let obj = { title: title, artist: artist, src: url, img: img };
    tracks.push(obj);

    el.addEventListener('click', () => {
        console.log(index);
        playTrack(index);
    });
});

const audio = new Audio();
let currentTrackIndex = 0;
let isPlaying = false;
let isLooping = false;

function playTrack(index) {
    currentTrackIndex = index;
    audio.src = tracks[index].src;
    document.getElementById('trackTitle').textContent = tracks[index].title;
    document.getElementById('trackArtist').textContent = tracks[index].artist;
    document.getElementById('trackImage').src = tracks[index].img;
    audio.play();
    isPlaying = true;
    document.getElementById('playPause').innerHTML = '<svg width="12" height="16" fill="none"><path d="M2 2v12m8-12v12" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path></svg>';
}

document.getElementById('playPause').addEventListener('click', () => {
    if (isPlaying) {
        audio.pause();
        document.getElementById('playPause').innerHTML = '<svg width="10" height="14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.403.673a1.071 1.071 0 011.14.147l6.429 5.358a1.071 1.071 0 010 1.646L2.543 13.18a1.071 1.071 0 01-1.757-.823V1.643c0-.415.24-.793.617-.97z" fill="currentColor"></path></svg>';
    } else {
        audio.play();
        document.getElementById('playPause').innerHTML = '<svg width="12" height="16" fill="none"><path d="M2 2v12m8-12v12" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path></svg>';
    }
    isPlaying = !isPlaying;
});

document.getElementById('prev').addEventListener('click', () => {
    currentTrackIndex = (currentTrackIndex - 1 + tracks.length) % tracks.length;
    playTrack(currentTrackIndex);
});

document.getElementById('next').addEventListener('click', () => {
    currentTrackIndex = (currentTrackIndex + 1) % tracks.length;
    playTrack(currentTrackIndex);
});

document.getElementById('loop').addEventListener('click', () => {
    isLooping = !isLooping;
    audio.loop = isLooping;
    if (isLooping) {
        document.getElementById('loop').classList.add('active');
    } else {
        document.getElementById('loop').classList.remove('active');
    }
});

document.getElementById('volume').addEventListener('input', (event) => {
    audio.volume = event.target.value;
});

audio.addEventListener('timeupdate', () => {
    const progressPercent = (audio.currentTime / audio.duration) * 100;
    const overlay = document.getElementById('progress').parentNode.querySelector('.range-overlay');
    overlay.style.width = `calc(${progressPercent}% ${progressPercent > 50 ? '- 2.5px' : '+ 2.5px'})`;

    document.getElementById('progress').max = audio.duration;
    document.getElementById('progress').value = audio.currentTime;
    document.getElementById('currentTime').textContent = formatTime(audio.currentTime);
    document.getElementById('duration').textContent = formatTime(audio.duration);
});

document.getElementById('progress').addEventListener('input', (event) => {
    audio.currentTime = event.target.value;
});

audio.addEventListener('ended', () => {
    if (!isLooping) {
        currentTrackIndex = (currentTrackIndex + 1) % tracks.length;
        playTrack(currentTrackIndex);
    }
});

function formatTime(seconds) {
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60);
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
}

function loadFirstTrack() {
    document.getElementById('trackTitle').textContent = tracks[0].title;
    document.getElementById('trackArtist').textContent = tracks[0].artist;
    document.getElementById('trackImage').src = tracks[0].img;
    audio.src = tracks[0].src;
}
loadFirstTrack();
